import thesis from './bullock_sayama_2023_replication.pdf';
import ukis_abstract from './ukis_2026_abstract.pdf'

export const projects = [
    {
        title: "On the Challenges of Unsupervised Speech Recognition in Tonal Languages and Semitic Languages",
        code: "",
        link: ukis_abstract,
        descr: `First authored extended abstract published to UKIS 2026.`,
        type: "Extended Abstract",
        topics: ["Automatic Speech Recognition", "Phonology", "Low-Resource Languages", "Multilingual ASR"]
    },
    {
        title: "Link Recommendation Algorithms",
        code: "https://github.com/jade-bejide/link-recommendation-algorithms",
        link: "",
        descr: `A range of link recommendation algorithms implemented in Python.`,
        type: "Research Code",
        topics: ["Recommendation Algorithms", "Social Networks", "Social Impact Theory", "Simulation"]
    },
    {
        title: "Weighted Directed Assortavity",
        code: "https://github.com/jade-bejide/wdnet-python",
        link: "",
        descr: `Weighted Directed Assorativity as described by Yuan et al (2021) implemented in Python.`,
        type: "Research Code",
        topics: ["Weighted Networks", "Assortativity"]
    },
    {
        title: "Heterogeneous Adaptive Social Network Model",
        code: "",
        link: thesis,
        descr: `Replication of Bullock and Sayama's (2023) Heterogeneous Adaptive Social Network Model. This work formed the foundation of my undergraduate thesis.`,
        type: "Paper Replication",
        topics: ["Social Networks", "Extremism", "Multi-agent systems"]
    }
]

// {
//     title: "",
//     grade: "",
//     link: "",
//     descr: "",
//     topics: []
// }